export default {"src":"/_next/static/media/nz-mountains.e163cc57.svg","height":227,"width":564};